export const GLOBAL_SWITCHES_RESET_STATE = 'GLOBAL_SWITCHES_RESET_STATE';
export const GLOBAL_SWITCHES_CURRENT_ITEM = 'GLOBAL_SWITCHES_CURRENT_ITEM';

export const GLOBAL_SWITCHES_REQUEST_LOADING = 'GLOBAL_SWITCHES_REQUEST_LOADING';
export const GLOBAL_SWITCHES_REQUEST_SUCCESS = 'GLOBAL_SWITCHES_REQUEST_SUCCESS';
export const GLOBAL_SWITCHES_REQUEST_FAILED = 'GLOBAL_SWITCHES_REQUEST_FAILED';

export const GLOBAL_SWITCHES_CURRENT_ACTION = 'GLOBAL_SWITCHES_CURRENT_ACTION';
export const GLOBAL_SWITCHES_RESET_ACTION = 'GLOBAL_SWITCHES_RESET_ACTION';